function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import axios from 'axios';
/**
 * Deep merges two objets.
 * @param  {Object} object destination object
 * @param  {Object} source source obejct
 *
 * @returns {Object} new object
 */

export var merge = function merge(object, source) {
  if (object === source) return object;

  var newValue = _extends({}, object, source);

  Object.entries(source).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];

    if (object[key] && typeof object[key] === 'object') {
      newValue[key] = merge(object[key], value);
    } else {
      newValue[key] = value;
    }
  });
  return newValue;
};

var _config = new WeakMap();

var _instance = new WeakMap();

var Api = /*#__PURE__*/function () {
  function Api(_config2) {
    var _this = this;

    _config.set(this, {
      writable: true,
      value: void 0
    });

    _instance.set(this, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "appendErrorInterceptor", function (interceptor) {
      _classPrivateFieldGet(_this, _instance).interceptors.response.use(function (r) {
        return r;
      }, interceptor);
    });

    _defineProperty(this, "appendInterceptor", function (addInterceptors) {
      addInterceptors(_classPrivateFieldGet(_this, _instance).interceptors);
    });

    _defineProperty(this, "get", function (url, config) {
      return _this.makeRequest('get', url, config);
    });

    _defineProperty(this, "post", function (url, config) {
      return _this.makeRequest('post', url, config);
    });

    _defineProperty(this, "put", function (url, config) {
      return _this.makeRequest('put', url, config);
    });

    _defineProperty(this, "patch", function (url, config) {
      return _this.makeRequest('patch', url, config);
    });

    _defineProperty(this, "del", function (url, config) {
      return _this.makeRequest('delete', url, config);
    });

    _defineProperty(this, "request", function (config) {
      return _classPrivateFieldGet(_this, _instance).request(config);
    });

    _classPrivateFieldSet(this, _config, _config2);

    _classPrivateFieldSet(this, _instance, axios.create(_config2));
  }

  var _proto = Api.prototype;

  _proto.update = function update(config) {
    _classPrivateFieldSet(this, _instance, axios.create(merge(_classPrivateFieldGet(this, _config), config)));
  };

  _proto.makeRequest = function makeRequest(method, url, options) {
    if (options === void 0) {
      options = {};
    }

    var headers = _extends({}, _classPrivateFieldGet(this, _instance).defaults.headers, options.headers);

    return _classPrivateFieldGet(this, _instance).call(this, _extends({}, options, {
      method: method,
      url: url,
      headers: headers
    })).then(function (resp) {
      return resp === null || resp === void 0 ? void 0 : resp.data;
    })["catch"](function (_ref2) {
      var response = _ref2.response;
      return Promise.reject(response);
    });
  };

  _proto.setAuthToken = function setAuthToken(auth_token) {
    if (auth_token) {
      _classPrivateFieldGet(this, _instance).defaults.headers.common.Authorization = "Bearer " + auth_token;
    } else delete _classPrivateFieldGet(this, _instance).defaults.headers.common.Authorization;
  };

  return Api;
}();

export default Api;